import { render, staticRenderFns } from "./EmptyListPlaceholder.vue?vue&type=template&id=37cb2acc"
import script from "./EmptyListPlaceholder.vue?vue&type=script&lang=ts"
export * from "./EmptyListPlaceholder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37cb2acc')) {
      api.createRecord('37cb2acc', component.options)
    } else {
      api.reload('37cb2acc', component.options)
    }
    module.hot.accept("./EmptyListPlaceholder.vue?vue&type=template&id=37cb2acc", function () {
      api.rerender('37cb2acc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EmptyListPlaceholder.vue"
export default component.exports